import { Checkbox, FormControlLabel, FormGroup, FormLabel } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { ITalentSearchFilterOption } from '../types';
import { AvatarWithStatusProps } from '@modules/talents/components/AvatarWithStatus';

interface StatusFilterProps {
  name: string;
  options: ITalentSearchFilterOption[];
}

export const getTalentStatusLabel = (status: AvatarWithStatusProps['status']): React.ReactNode => {
    switch (status) {
        case 'open':
            return 'Disponible';
        case 'closed':
            return 'Non disponible';
        case 'inactive':
            return 'Inactif';
        case 'looking':
            return 'À l\'écoute';
        case 'mixed':
            return 'Statuts mixtes';
        case 'nothing':
        default:
            return 'Non renseigné';
    }
};

const StatusFilter = ({ name, options }: StatusFilterProps) => {
  const { control } = useFormContext();


  return (
    <FormGroup>
      <FormLabel>Statut</FormLabel>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            {options.map((opt) => (
              <FormControlLabel
                key={opt.value}
                control={
                  <Checkbox
                    checked={(field.value || []).includes(opt.value)}
                    onChange={(e) => {
                      const current = field.value || [];
                      field.onChange(
                        e.target.checked
                          ? [...current, opt.value]
                          : current.filter((v: string) => v !== opt.value),
                      );
                    }}
                  />
                }
                label={`${getTalentStatusLabel(opt.value as AvatarWithStatusProps['status'])} (${opt.count})`}
              />
            ))}
          </>
        )}
      />
    </FormGroup>
  );
};

export default StatusFilter;
